<!--
 * @Description: 广水市农业供应链数字平台大数据中心 - 顶部标题栏
 * @Author: xiawenlong
 * @Date: 2026-04-01
-->
<template>
  <div id="top-header-agriculture">
    <a class="center-title" href="https://gssjyp.com/about.html" target="_blank"
      >广水市农业供应链数字平台大数据中心</a
    >
    <div class="clock">
      <div class="date">
        <span>{{ date }}</span>
        <span class="week">{{ week }}</span>
      </div>
      <div class="time">{{ time }}</div>
    </div>
    <div class="sysInfo">
      <div class="day">
        平台安全运行
        <span>{{ days }}天</span>
      </div>
    </div>
  </div>
</template>

<script>
import { plaformInfo } from '@/api/agriculture-dashboard'
import to from 'await-to'

export default {
  name: 'TopHeader',
  data() {
    return {
      date: '',
      time: '',
      week: '',
      weather: '',
      days: '',
      safeStatus: '',
    }
  },
  mounted() {
    this.currentTime()
    this.getWeather()
    setInterval(() => {
      this.getWeather()
    }, process.env.VUE_APP_LTIME || 300000)
  },
  // 销毁定时器
  beforeDestroy() {
    if (this.formatDate) {
      clearInterval(this.formatDate) // 在Vue实例销毁前，清除时间定时器
    }
  },
  methods: {
    currentTime() {
      setInterval(this.formatDate, 500)
    },
    formatDate() {
      let date = new Date()
      let year = date.getFullYear() // 年
      let month = date.getMonth() + 1 // 月
      let day = date.getDate() // 日
      let week = date.getDay() // 星期
      let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      let hour = date.getHours() // 时
      let minute = date.getMinutes() // 分
      minute = minute < 10 ? '0' + minute : minute // 如果只有一位，则前面补零

      this.date = `${year}-${month}-${day}`
      this.time = `${hour}:${minute}`
      this.week = `${weekArr[week]}`
    },
    async getWeather() {
      const [res, err] = await to(plaformInfo())
      if (err) return
      this.days = res.data.days
      this.weather = res.data.weather
      this.safeStatus = res.data.safeStatus
    },
  },
}
</script>

<style lang="scss">
#top-header-agriculture {
  position: relative;
  width: 100%;
  height: 160px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  background: url('~@/img/agriculture/top_bg.png');
  background-size: 100%;

  .center-title {
    position: absolute;
    left: 50%;
    top: 44px;
    line-height: 65px;
    transform: translateX(-50%);
    font-size: 72px;
    text-align: center;
    color: #ffffff;
    font-weight: 700;
  }

  .clock,
  .sysInfo {
    position: absolute;
    top: 38px;
  }

  .clock {
    left: 144px;
    display: flex;
    align-items: center;

    font-size: 36px;
    color: #eee;

    .date {
      margin-right: 40px;

      span {
        margin-right: 10px;
      }
    }
  }

  .sysInfo {
    right: 223px;
    display: flex;
    align-items: center;

    .day {
      display: flex;
      align-items: center;
      font-size: 36px;
      color: #eee;

      span {
        margin-left: 27px;
      }
    }

    .status {
      font-size: 30px;
      color: #ffffff;

      span {
        color: #66ffff;
        margin-left: 27px;
      }
    }
  }
}
</style>
